import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import MainPage from './MainPage';
import News from './News';
import Recruitment from './Recruitment';
import Partners from './Partners';
import Students from './Students';
import Teachers from './Teachers';
import Contact from './Contact';
import Links from './Links';
import StudentsGallery from './StudentsGallery';
import JobShadowing from './JobShadowing';
import Course from './Course';
import JobShadowingGallery from './JobShadowingGallery';
import CourseGallery from './CourseGallery';
import DisseminationGallery from './DissemiationGallery';
import WhatsUp from './WhatsUp';
import ErasmusDaysGallery from './ErasmusDaysGallery';

let App = () => {
  return (
    <BrowserRouter basename='/2024'>
      <Routes>
        <Route path = "/" element = {<Layout />}>
          <Route index element = {<MainPage />} />
          <Route path = "/aktualnosci" element = {<News />} />
          <Route path = "/rekrutacja" element = {<Recruitment />} />
          <Route path = "/partnerzy" element = {<Partners />} />
          <Route path = "/uczniowie" element = {<Students />} />
          <Route path = "/uczniowie/galeria" element = {<StudentsGallery />} />
          <Route path = "/jobshadowing" element = {<JobShadowing />} />
          <Route path = "/jobshadowing/galeria" element = {<JobShadowingGallery />} />
          <Route path = "/kurs" element = {<Course />} />
          <Route path = "/kurs/galeria" element = {<CourseGallery />} />
          <Route path = "/kontakt" element = {<Contact />} />
          <Route path = "/linki" element = {<Links />} />
          <Route path = "/erasmusdays/galeria" element = {<ErasmusDaysGallery />} />
          <Route path = "/upowszechnianie/galeria" element = {<DisseminationGallery />} />
          <Route path = "/uczniowie/whatsup" element = {<WhatsUp />} /> 
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
